// extracted by mini-css-extract-plugin
export default {"Main":"SocialLinks_Main__sHj--","fb":"SocialLinks_fb__qUEi1","in":"SocialLinks_in__Sqq8P","yt":"SocialLinks_yt__oA7yK","tw":"SocialLinks_tw__kmBHY"};